module.exports = __webpack_public_path__ + "static/media/smart-money-ss.fba7ed71.png";